import PushpinIcon from "./PushpinIcon.mjs";

export default class MyNoteIcon extends PushpinIcon {}
